import React, { useState } from "react";
import { Home, PlayCircle, BarChart3, Bell, Users, User } from "lucide-react";
import M2TMobileScreen from "./M2TMobileScreen";

const NAV_TABS = [
  { key: "feed", icon: <Home className="w-4 h-4" /> },
  { key: "video", icon: <PlayCircle className="w-4 h-4" /> },
  { key: "chart", icon: <BarChart3 className="w-4 h-4" /> },
  { key: "alerts", icon: <Bell className="w-4 h-4" /> },
  { key: "directory", icon: <Users className="w-4 h-4" /> },
  { key: "profile", icon: <User className="w-4 h-4" /> },
];

export default function RightRailMobilePreviewM2T() {
  const [tab, setTab] = useState("feed");

  return (
    <div className="flex flex-1 h-full items-center justify-center min-h-0 min-w-0 p-2">
      <div
        className="
          relative
          bg-[#1a1f2a] border-[3px] border-white rounded-[16px] shadow-xl
          flex flex-col overflow-hidden
          w-full h-full
          max-w-[220px] max-h-[440px]
          aspect-[1/2]   // Maintains perfect shape at any size
          p-1
        "
        style={{
          // This ensures smooth scaling inside any flex parent!
          margin: "auto",
        }}
      >
        {/* Speaker Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[16%] min-w-[24px] max-w-[36px] h-[6px] bg-black/80 rounded-xl z-20" />
        {/* Mobile Screen */}
        <div className="relative w-full h-full overflow-hidden">
          <M2TMobileScreen tab={tab} setTab={setTab} />
          {/* Bottom Navigation */}
          <div className="absolute bottom-0 left-0 w-full py-2 bg-[#171a22] flex justify-around items-center border-t border-slate-800 z-20">
            {NAV_TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`flex flex-col items-center ${tab === t.key ? "text-sky-400" : "text-slate-400"} transition`}
              >
                {t.icon}
              </button>
            ))}
          </div>
          {/* Home indicator bar */}
          <div className="absolute left-1/2 -translate-x-1/2 bottom-[5px] w-[27%] min-w-[32px] max-w-[54px] h-[5px] rounded-full bg-gray-600/50" />
        </div>
      </div>
    </div>
  );
}
